module.exports = __webpack_public_path__ + "img/logo.d86b588a.png";